<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="签署合同"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
       
        <el-form-item label="职位信息" prop="job_id" >  
           <el-select
                v-model="selectedJob" 
                placeholder="请选择入职职位"
                clearable
                filterable
                style="width:100%"
                value-key="job_id"
                @change="selectJob"
              >
              <el-option
                v-for="item in jobList"
                :key="item.job_id"
                :label="item.title"
                :value="item"
              />
          </el-select>
        </el-form-item>
        <el-form-item label="入职时间" prop="check_time" >  
          <el-date-picker
            v-model="formData.check_time"
            type="datetime"
            placeholder="请选择入职时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="联系方式	" prop="mobile" >
          <el-input  type="number" v-model="formData.mobile" placeholder="请输入联系方式"></el-input>
        </el-form-item>


        <el-form-item label="地址信息	" prop="j_address_id" >
          <el-select
                v-model="selectedAddress" 
                placeholder="请选择入职地址"
                clearable
                filterable
                style="width:100%"
                value-key="j_address_id"
                @change="selectAddress"
              >
              <el-option
                v-for="item in addressList"
                :key="item.j_address_id"
                :label="item.adname"
                :value="item"
              />
          </el-select>
        </el-form-item>


        <el-form-item label="入职通知" prop="mark">
          <el-input 
          type="textarea" 
          v-model="formData.mark"  
          :rows="4"
            placeholder="输入入职通知"></el-input>
        </el-form-item>

        <el-form-item label="选择合同" prop="contract_type">
          <el-row>
            <el-radio-group v-model="formData.contract_type" size="small" @input="selectContractType">
              <el-radio-button label="1">使用平台合同</el-radio-button>
              <el-radio-button label="2">上传本地合同</el-radio-button>
            </el-radio-group>
          </el-row>

          <el-row v-if="formData.contract_type==1">
            <div class="file-cont">
                <div>
                  <img src="@/assets/chat-img/chat-contract.png"></img>
                  <b>平台合同</b>
                </div>
                <el-link type="primary">点击查看</el-link>
            </div>
          </el-row>


          <el-row v-if="formData.contract_type==2">
            <div class="file-cont2" v-if="formData.contract_file">
                <div>
                  <img src="@/assets/chat-img/chat-contract.png"></img>
                  <b>{{formData.contract_fname}}</b>
                </div>
                <el-link type="primary">点击查看</el-link>

                <img class="close" @click="removeFile"  src="@/assets/image/contract_remove.png"/>
            </div>

            <div v-else class="file-upload" >
              <el-upload
                class="upload"
                :action="uploadFileUrl"
                :file-list="fileList"
                :limit="1"
                :on-error="handleUploadError"
                :on-exceed="handleExceed"
                :on-success="handleUploadSuccess"
                :show-file-list="false"
            >
                <div class="el-upload__text">点击上传</div>
              </el-upload>
            </div>
          </el-row>
        </el-form-item>
       
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>


  </el-dialog>
</template>

<script>
import { jobList,addressAdd,contractAdd} from "@/api/chat/index";
import urlConfig from '@/api/config'

export default {
  components: { },

  data() {
    return {
      visible: false,
      uploadFileUrl:  urlConfig.prod.baseURL +"/web/file/Upload", // 上传的图片服务器地址
      fileList: [],
      jobList:[],
      selectedJob:null,
      selectedJob:{},
      selectedAddress:{},
      addressList:[],
      formData: {
        contract_type:1,
        user_app_id:"",
        check_time: "",
        job_id:"",
        mobile:"",
        j_address_id: "",
        mark:'',
        contract_fname:'',
        contract_file:''
        
       
      },
       rules: {
        contract_type: [
              {required: true, message: '请选择合同', trigger: 'blur'}
          ],
          check_time: [
              {required: true, message: '请选择入职时间', trigger: 'blur'}
          ],
          job_id: [
              {required: true, message: '请选择职位', trigger: 'change'}
          ],
          mobile: [
              {required: true, message: '请输入联系方式', trigger: 'blur'}
          ],
          j_address_id: [
              {required: true, message: '请输入入职地址', trigger: 'change'}
          ],
          mark: [
              {required: true, message: '请输入入职通知', trigger: 'blur'}
          ]

       }
    };
  },

 
  mounted() {

},
destroyed(){

},
  
  methods: {
    handleClose() {
     
      this.fileList=[];
      this.jobList=[];
      this.selectedJob=null;
      this.selectedJob={};
      this.selectedAddress={};
      this.addressList=[];
      this.$refs["form"].resetFields();
      this.visible = false;

    },


    init(user_app_id) {
      console.log(user_app_id);
      this.visible = true;
      this.formData.user_app_id=user_app_id;
      
      this.initJobList();
    },

    initJobList(){
      var that = this;
      jobList({}).then((response) => {
        that.jobList = response.data;
      });
    },
    
    selectJob(e){
      this.selectedJob=e;
      console.log("selectJob",e);
      if(e){
        this.formData.job_id=e.job_id;
        this.addressList=e.address;
      }
    },
    selectAddress(e){
      this.selectedAddress=e;
      this.formData.j_address_id=e.j_address_id;
      
    },

    selectContractType(e){

    },

    removeFile(){
      this.fileList=[];
      this.formData.contract_file='';
      this.formData.contract_fname='';
    },


     // 文件个数超出
     handleExceed() {
      this.$message.error(`只允许上传单个文件`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      console.log(res);
      this.formData.contract_file=res.file;
      this.formData.contract_fname=res.filename;
      this.$message.success("上传成功");
      console.log(this.formData);
     
    },
  
    // 获取文件名称
    getFileName(name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
      } else {
        return "";
      }
    },

    submit(){
      var that=this;
      if(that.formData.contract_type==1){
        that.formData.contract_fname="";
        that.formData.contract_file="";
      }else{
        if(that.formData.contract_file==""){
          this.$message.warning("请上传合同");
          return;
        }
      }
      this.$refs["form"].validate((valid) => {
          if (valid) {
            contractAdd(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
               var enroll_id=response.enroll_id;
                that.$emit('callback',19,enroll_id);
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          }
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }

  .file-cont{
    display: flex;
    justify-content: space-between;
    border: 1px solid #CCCCCC;    
    border-radius: 3px;
    margin-top: 20px;
    padding: 10px;

    div{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      align-self: center;
      img{
        width: 30px;
      }
      b{
        color: #333333;

      }
    }
  
  }


  .file-cont2{
    display: flex;
    justify-content: space-between;
    border: 1px solid #CCCCCC;    
    border-radius: 3px;
    margin-top: 20px;
    padding: 10px;
    position: relative;

    .close{
      position: absolute;
      right: -7px;
      top: -7px;
      width: 15px;
    }

    div{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      align-self: center;
      img{
        width: 30px;
      }
      b{
        color: #333333;

      }
    }
  
  }

  .upload{
    text-align: center;
    border: 1px solid #4C71DB;
    padding: 20px;
    margin-top:20px;
    border-radius: 3px;

  }
</style>
